import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import { onFormChangeUniversal } from './functions/onFormChange';
import * as React from 'react';
import { TriggerService } from '../../core/trigger/trigger_service';
import { validateFieldUniversal } from './functions/validateField';
import { WFormData } from '../../core/forms/WFormFramework';
import { WFormsTableWrapper } from '../../core/table/WFormsTableWrapper';

export interface DateneingabeBetrieblicheDatenMotivationProps {
    data: any;
}

export class DateneingabeBetrieblicheDatenMotivation extends React.Component<DateneingabeBetrieblicheDatenMotivationProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
        this.validateField = this.validateField.bind(this);
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    render(): JSX.Element {
        return (
            <div>
                <WFormsTableWrapper
                    entity={IDs.ENT_CFM_MOTIVATION}
                    module={IDs.MOD_ETOOL}
                    actions={['add', 'edit', 'delete']}
                    customClass='Custom-ETA'
                    formLayout='flowV2'
                    customCssStyle={{
                        formField: {
                            motivation: { styleTextarea: { height: 150 } },
                            vorstellung: { styleTextarea: { height: 150 } },
                            systemgrenzen: { styleTextarea: { height: 150 } },
                            umweltzertifizierungen: { styleTextarea: { height: 150 } }
                        }
                    }}
                    validateField={this.validateField}
                    validRestriction='stop'
                    onFormChangeInteractive={(formData: WFormData, onValueChange: (name: string, value: any) => void) => {
                        const tid: number = ((formData || {} as any).values || {}).tid;
                        let oldFormValues;
                        if (!tid && formData.getValue('_SYS_INFORMED')) {
                            formData.setValue('_SYS_INFORMED', false);
                        }
                        oldFormValues = ((this.props.data || {})[IDs.ENT_CFM_MOTIVATION] || []).find((r: any) => r.tid === tid);
                        onFormChangeUniversal(IDs.ENT_CFM_MOTIVATION, formData, null, this.props.data, oldFormValues);
                    }}
                    onDelDone={() => this.triggerService.fire('reload', IDs.ENT_CFM_MOTIVATION)}
                    onSaveDone={() => this.triggerService.fire('reload', IDs.ENT_CFM_MOTIVATION)}
                />
            </div>
        );
    }

    validateField(key: string, value: any, data: any, onValueChange: (name: string, value: any) => void): string {
        return validateFieldUniversal(IDs.ENT_CFM_MOTIVATION, key, value, data, onValueChange, this.props.data);
    }
}
